import { useHandleTransactionRequest } from "./useHandleTransactionRequest";

type ApiAssetId =
  | { tag: "Ada" }
  | { tag: "NativeToken"; policyId: string; assetName: string };

type ApiAssetValue = {
  asset: ApiAssetId;
  value: number;
};

type WithdrawPayload = {
  value: { assets: ApiAssetValue[] };
};

/**
 * Withdraw, cancelling any resting orders first when ada is involved.
 *
 * An account that drains its ada while orders rest can no longer cover its own
 * evacuation output. Its orders stay on the book and become unmatchable: every
 * fill re-emits the maker's evacuation output, so a trade against one fails and
 * takes the counterparty's WHOLE transaction with it. One such order walls off
 * its price level for every participant, and the seller sees no error at all.
 *
 * Only ada triggers the cancel. Withdrawing a token cannot strand anything, so
 * resting orders are left alone.
 */
export const useHandleWithdrawRequest = () => {
  return useHandleTransactionRequest<WithdrawPayload>("Withdraw", {
    cancelRestingOrdersFirst: (payload) =>
      payload.value.assets.some((a) => a.asset.tag === "Ada"),
  });
};
